export default "__VITE_ASSET__520pBgal__"